module.exports = __webpack_public_path__ + "static/media/notes_intro_img_1.da983fd0.png";